import styled from 'styled-components';
import { VoxityAppPicker } from '@voxityai/auth/components';
import { color } from 'theme';
import { darken, hexToRgba, replaceAlpha } from 'react-rainbow-components/styles/helpers/color';
import {
    GREY_100, GREY_800, PURPLE_500, WHITE,
} from '../../constants';

const colorHightlight = hexToRgba(GREY_100);

export const DropdownContainer = styled.div`
    background-color: ${WHITE};
    box-sizing: border-box;
    color: ${GREY_800};
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.06), 0px 8px 24px 0px rgba(75, 70, 92, 0.16);
    min-width: 16rem;
    max-width: 24rem;
    width: auto;
    border-radius: 0.75rem;
    display: flex;
    flex-direction: column;
    min-height: 8rem;
    max-height: 24rem;
    overflow-y: auto;
    padding: 0.5rem;

    a {
        text-decoration: none;
        color: ${PURPLE_500} !important;
        font-size: 0.75rem;
        font-weight: 500;

        &:hover {
            text-decoration: none;
            color: ${color('text.main')} !important;
            background: ${PURPLE_500}29;
        }

        svg {
            color: ${PURPLE_500} !important;
        }
    }

    .animate-pulse {
        animation: unset;

        &> div {
            background-color: unset;
            background: ${colorHightlight}
                linear-gradient(
                    90deg,
                    ${replaceAlpha(colorHightlight, 0.1)} 0%,
                    ${darken(colorHightlight, 0.1)} 50%,
                    ${replaceAlpha(colorHightlight, 0.1)} 100%
                );
            background-size: 400% 400%;
            animation: gradient 1s ease-in-out infinite;
        }
    }

    @keyframes gradient {
        0% {
            background-position: 14% 0;
        }

        50% {
            background-position: 87% 100%;
        }

        100% {
            background-position: 14% 0;
        }
    }
`;

export const StyledVoxityAppPicker = styled(VoxityAppPicker)`
    width: fit-content;
    max-width: 24rem;
`;
